import Vue from 'vue';
import axios from 'axios';
import { gmapApi } from 'vue2-google-maps';

export default {
  name: 'GoogleMapLocation',
  props: ['dataObj'],
  data: function () {
    return {
      geoLocation: null,
      gMapPosition: { lat: 0, lng: 0 },
      accuracy: 0,
      gMapPositionStart: { lat: 0, lng: 0 },
      gMapPositionMove: { lat: 0, lng: 0 },
      markerTitle: this.$t('messages.MarkerTitle'),
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -50
        }
      },
      bDraggable: true,
      bClickable: true,
      bEditLocation: false,
      readOnly: false,
      errorMessage: '',
      message: '',
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {

  },
  created() {
    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    var geo = navigator.geolocation.getCurrentPosition(
      (pos) => {
        this.gMapPosition.lat = pos.coords.latitude;
        this.gMapPosition.lng = pos.coords.longitude;
        this.accuracy = pos.coords.accuracy;
      },
      (err) => { this.$alertMsg(err.message); },
      geoOptions
    );
    this.$root.$on('gmap_location_updated', this.init);
    this.init;
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.gMapPosition = this.dataObj.gMapPosition;
        this.gMapPositionStart = this.dataObj.gMapPositionStart;
        this.gMapPositionMove = this.dataObj.gMapPositionMove;
        this.markerTitle = this.dataObj.markerTitle;
        this.infoContent = this.dataObj.infoContent;
        this.infoWindowPos = this.dataObj.infoWindowPos;
        this.infoWinOpen = this.dataObj.infoWinOpen;
        this.infoOptions = this.dataObj.infoOptions;
        this.bDraggable = this.dataObj.bDraggable;
        this.bClickable = this.dataObj.bClickable;
        this.bEditLocation = this.dataObj.bEditLocation;
        this.readOnly = this.dataObj.readOnly;

        if (this.gMapPosition.lat === 0)
          this.getGeoLocation();

        setTimeout(() => {
          var map = this.$refs.myMap;
          map.$mapObject.setOptions({ disableDoubleClickZoom: true });
          
          this.google.maps.event.addListener(map.$mapObject, 'dblclick', (e) => {
            var positionDoubleclick = e.latLng;
            this.setMarker(positionDoubleclick);
          });

        }, 1000);
      });
    },
    setMarker(latLng) {
      if (this.readOnly)
        return;

      this.dataObj.gMapPosition.lat = latLng.lat();
      this.dataObj.gMapPosition.lng = latLng.lng();

      var marker = this.$refs.myMarker;
      marker.$markerObject.setPosition(latLng);
      this.$alertMsg(this.$t('messages.LocationPointSuccess'), 2);
    },
    getGeoLocation() {
      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      var geo = navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.gMapPosition.lat = pos.coords.latitude;
          this.gMapPosition.lng = pos.coords.longitude;
          this.accuracy = pos.coords.accuracy;
        },
        (err) => { this.$alertMsg(err.message); },
        geoOptions
      );
    },
    gMapDragEnd(evnt) {
      this.gMapPosition.lat = evnt.lat();
      this.gMapPosition.lng = evnt.lng();
      this.dataObj.gMapPosition.lat = evnt.lat();
      this.dataObj.gMapPosition.lng = evnt.lng();
      //this.bEditLocation = false;
      //this.dataObj.bEditLocation = false;
      this.$alertMsg(this.$t('messages.LocationPointSuccess'), 2);
    },
    gMapDrag(evnt) {
      this.gMapPositionMove.lat = evnt.lat();
      this.gMapPositionMove.lng = evnt.lng();
    },
    gMapDragStart(evnt) {
      this.gMapPositionStart.lat = evnt.lat();
      this.gMapPositionStart.lng = evnt.lng();
    },
    toggleInfoWindow: function (evnt) {
      this.gMapPositionMove.lat = evnt.lat();
      this.gMapPositionMove.lng = evnt.lng();
      this.infoWindowPos = this.gMapPositionMove;
      this.infoWinOpen = !this.infoWinOpen;
    },
    closeMapDialog() {
      this.bEditLocation = false;
      this.dataObj.bEditLocation = false;
    },
  }

}
